<head>
  <script src="https://api.mapbox.com/mapbox-gl-js/v3.11.0/mapbox-gl.js"></script>
  <link
    href="https://api.mapbox.com/mapbox-gl-js/v3.11.0/mapbox-gl.css"
    rel="stylesheet"
  />
  <link href="https://unpkg.com/primeflex/primeflex.css" rel="stylesheet" />
</head>
<div class="ioh-map" #iohMapWrapper>
  <div id="IOHMap"></div>
  <div id="extentScale" class="extent-scale" *ngIf="iohMapService.activeMapSlot() !== 'level1'">
    Extent {{ this.iohMapService.iohZoomLevel() }}
  </div>
  <csx-map-service-icons *ngIf="iohMapService.activeMapSlot() !== 'level1'"></csx-map-service-icons>
  <p-toast key="missingTrainInMap" position="top-center" />
</div>
